import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/api';
import { Button, Form, Input, Card, Typography, Divider, Alert } from 'antd';
import { LockOutlined, UserOutlined } from "@ant-design/icons";

const { Title } = Typography;

function Login() {
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // Always clear token on visiting login page
    useEffect(() => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('userRole');
    }, []);

    const handleSubmit = async (values) => {
        setLoading(true);
        setError('');

        try {
            const res = await api.post('/login', {
                username: values.username,
                password: values.password,
            });

            const { token, user } = res.data;
            localStorage.setItem('token', token);
            localStorage.setItem('user', JSON.stringify(user));
            localStorage.setItem('userRole', user.role); // Store role separately for easy access

            // Redirect based on role
            navigate('/dashboard');
        } catch (err) {
            setError(err.response?.data?.message || 'Login failed. Please check your credentials.');
            setLoading(false);
        }
    };

    return (
        <div style={{
            background: 'linear-gradient(135deg, #1E293B 0%, #334155 100%)',
            minHeight: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '20px'
        }}>
            <Card
                style={{
                    width: '100%',
                    maxWidth: 420,
                    borderRadius: 12,
                    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)'
                }}
                bordered={false}
            >
                <div style={{ textAlign: 'center', marginBottom: 24 }}>
                    <Title level={3} style={{ color: '#1E293B', margin: 0 }}>
                        Welcome to Dominosoft
                    </Title>
                    <p style={{ color: '#64748B' }}>Vehicle Rental Management System</p>
                </div>

                {error && (
                    <Alert
                        message={error}
                        type="error"
                        showIcon
                        style={{ marginBottom: 24 }}
                    />
                )}

                <Form
                    name="login-form"
                    onFinish={handleSubmit}
                    layout="vertical"
                >
                    <Form.Item
                        name="username"
                        rules={[{ required: true, message: 'Please input your username!' }]}
                    >
                        <Input
                            prefix={<UserOutlined style={{ color: '#94A3B8' }} />}
                            placeholder="Username"
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        rules={[{ required: true, message: 'Please input your password!' }]}
                    >
                        <Input.Password
                            prefix={<LockOutlined style={{ color: '#94A3B8' }} />}
                            placeholder="Password"
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            block
                            size="large"
                            loading={loading}
                            style={{
                                background: '#3B82F6',
                                border: 'none',
                                height: 42,
                                fontWeight: 500
                            }}
                        >
                            Sign In
                        </Button>
                    </Form.Item>

                    <Divider style={{ color: '#94A3B8', fontSize: 12 }}>
                        DOMINOSOFT © {new Date().getFullYear()}
                    </Divider>
                </Form>
            </Card>
        </div>
    );
}

export default Login;